var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9649_483801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1364 23.3636H13.1364V11.9091H22.1364M22.1364 10.2727H13.1364C12.7024 10.2727 12.2862 10.4451 11.9793 10.752C11.6724 11.0589 11.5 11.4751 11.5 11.9091V23.3636C11.5 23.7976 11.6724 24.2138 11.9793 24.5207C12.2862 24.8276 12.7024 25 13.1364 25H22.1364C22.5704 25 22.9866 24.8276 23.2935 24.5207C23.6003 24.2138 23.7727 23.7976 23.7727 23.3636V11.9091C23.7727 11.4751 23.6003 11.0589 23.2935 10.752C22.9866 10.4451 22.5704 10.2727 22.1364 10.2727ZM19.6818 7H9.86366C9.42967 7 9.01345 7.1724 8.70657 7.47928C8.3997 7.78616 8.22729 8.20237 8.22729 8.63636V20.0909H9.86366V8.63636H19.6818V7Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9649_483801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c67028a2cf9bff20be65299b634d5d0d.svg";
export { ForwardRef as ReactComponent };